// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tree[data-v-91a47dc8] {\n  min-width: 100%;\n  display: inline-block;\n}\n.tree[data-v-91a47dc8] {\n  overflow: auto;\n  max-height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
